export const getMyBoards = <
  TMember extends { id: string; idBoards: Array<string> } & {
    boards: {
      id: string;
      memberships: {
        id: string;
        idMember: string;
        memberType: 'admin' | 'normal' | 'observer';
      }[];
    }[];
  },
>(
  member: TMember,
): TMember['boards'] => {
  const inIdBoards = new Map<string, boolean>();
  if (member.idBoards) {
    member.idBoards.forEach((id) => inIdBoards.set(id, true));
  }

  return member.boards.filter(
    ({ id, memberships }) =>
      inIdBoards.get(id) &&
      memberships.some(({ idMember }) => idMember === member.id),
  );
};
